import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
// Hooks
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import Bill from 'modules/billing/components/PaymentModal/Bill'
import usePlanName from 'modules/billing/hooks/usePlanName'
import plans, { subscriptionPlan } from 'modules/billing/store/collections/plans'
import subscriptions from 'modules/billing/store/collections/subscriptions'

interface Props {
  onClose: () => void
}

const UpgradeSubscriptionModal = ({ onClose }: Props) => {
  const subscription = subscriptions.current
  const plan = subscriptionPlan(subscription)
  const planName = usePlanName(plan.family)

  const upgradePlan = plans.find({
    id: plan?.attributes.upgrade_plan_id,
  })

  const { running, performAction: onSubmit } = useAsyncAction(
    async (closePortal: ClosePortalFn) => {
      const { success } = await subscription.rpcSchedulePlanChange()

      if (!success) {
        app.setFlash({
          type: 'wrong',
          message: i18n.t('errors.generic_saving'),
        })
      }

      closePortal()
    }
  )

  if (!upgradePlan) return null

  const currentSeats = subscriptions.current.attributes.current_cycle_quantity_on_payment_gateway

  return (
    <AuthorizeUser>
      <Modal
        illustration="fireworks"
        title={i18n.t('billing.your_plan.upgrade.title')}
        description={i18n.t('billing.your_plan.upgrade.description')}
        onClose={onClose}
        onSubmit={onSubmit}
        footer={
          <Button disabled={running} submit>
            {i18n.t('billing.your_plan.upgrade.confirm')}
          </Button>
        }
      >
        <Bill
          planIntervalReadonly
          plan={upgradePlan}
          planName={planName}
          currentSeats={currentSeats}
        />
      </Modal>
    </AuthorizeUser>
  )
}

export default observer(UpgradeSubscriptionModal)
